export default "/images/claritick-shape-2.svg?79aa18a39947552f28645c28680ff8fa";